
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.625 24a.75.75 0 01-.624-.334l-1.5-2.25A.753.753 0 01.375 21V9.75c0-1.241 1.009-2.25 2.25-2.25s2.25 1.009 2.25 2.25v2.362l4.5-5.625V3c0-1.654 1.346-3 3-3s3 1.346 3 3v3.517l7.09 10.313a2.652 2.652 0 01-.055 3.068l1.062 1.399a.745.745 0 01.146.555.743.743 0 01-.29.496.741.741 0 01-.453.153.744.744 0 01-.598-.297l-1.066-1.403a2.645 2.645 0 01-3.035-.889l-.034-.046-6.052-8.486-5.865 7.82a.754.754 0 01-.6.3h-.75V21a.753.753 0 01-.126.416l-1.5 2.25a.749.749 0 01-.624.334zm0-2.102l.75-1.125V19.5h-1.5v1.273l.75 1.125zm16.757-2.88a1.13 1.13 0 00.912.45c.245 0 .479-.079.679-.229a1.138 1.138 0 00.256-1.559l-6.63-9.644-1.564 2.085 6.347 8.897zM5.25 18l7.875-10.5h-2.64L4.71 14.719a.814.814 0 01-.231.19c-.014.008-.031.018-.049.026a.796.796 0 01-.305.065h-2.25v3H5.25zm-1.875-4.5V9.75a.75.75 0 00-1.5 0v3.75h1.5zm10.5-7.5V3c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v3h3z"}})])
          )
        }
      }
    